import { render, staticRenderFns } from "./brandSet.vue?vue&type=template&id=fd1fc048&"
import script from "./brandSet.vue?vue&type=script&lang=js&"
export * from "./brandSet.vue?vue&type=script&lang=js&"
import style0 from "./brandSet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports